/* ELAL HOME — theme interactions + Shopify AJAX cart */
(function () {
  "use strict";
  var d = document;
  var routes = window.routes || { root_url: "/", cart_url: "/cart", cart_add_url: "/cart/add", cart_change_url: "/cart/change" };

  /* ---- scroll reveals ---- */
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var revs = d.querySelectorAll(".reveal");
  if (reduce || !("IntersectionObserver" in window)) {
    revs.forEach(function (el) { el.classList.add("in"); });
  } else {
    var rio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        // stagger items that share a parent (cards in a grid, craft steps, promises)
        var parent = el.parentElement;
        var group = parent ? Array.prototype.filter.call(parent.children, function (c) { return c.classList.contains("reveal"); }) : [el];
        var idx = group.indexOf(el);
        var delay = Math.min(idx, 5) * 80;
        el.style.transitionDelay = delay + "ms";
        el.classList.add("in");
        // clear the delay once it has played so hover stays instant
        setTimeout(function () { el.style.transitionDelay = ""; }, delay + 1200);
        rio.unobserve(el);
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" });
    revs.forEach(function (el) { rio.observe(el); });
  }

  /* ---- header: transparent over hero, solid after (homepage only) ---- */
  var nav = d.getElementById("siteNav");
  var hero = d.querySelector(".hero");
  if (nav && hero && !nav.classList.contains("is-static") && "IntersectionObserver" in window) {
    new IntersectionObserver(function (e) {
      nav.classList.toggle("scrolled", !e[0].isIntersecting);
    }, { rootMargin: "-70px 0px 0px 0px" }).observe(hero);
  }

  /* ---- hero background video ----------------------------------------
     The <video> ships with no src. A source is attached only once we've
     decided the bytes are worth it, and the poster underneath is a real
     hero image rather than a placeholder — so every path where we decline
     still leaves a finished-looking hero.

     We decline for: reduced-motion, Save-Data, 2G-class connections, and
     phones when the merchant has switched mobile video off. We also pick
     the smallest source that still covers the viewport class instead of
     always pulling the largest file. */
  var heroVideo = d.querySelector("[data-hero-video]");
  if (heroVideo) {
    (function (video) {
      var started = false;
      var visible = true;
      var loadedUrl = null;
      var mqDesktop = window.matchMedia("(min-width: 901px)");
      var mqPortrait = window.matchMedia("(orientation: portrait)");

      // "1280::https://..." tokens. Shopify hands back protocol-relative URLs
      // ("//cdn.shopify.com/..."), which is why the delimiter is "::" and the
      // split is on the FIRST occurrence — a naive split(":") would shred them.
      function parseSources(attr) {
        return (video.getAttribute(attr) || "")
          .split(/\s+/)
          .map(function (tok) {
            var i = tok.indexOf("::");
            if (i < 1) return null;
            var url = tok.slice(i + 2);
            return url ? { w: parseInt(tok.slice(0, i), 10) || 0, url: url } : null;
          })
          .filter(Boolean)
          .sort(function (a, b) { return a.w - b.w; });
      }

      // Portrait gets its own crop of the film, because the 3:1 desktop crop
      // can only show a 210px-wide slice of the frame in a tall box. If the
      // merchant hasn't uploaded one, fall back to the desktop file.
      function sourcesForNow() {
        if (mqPortrait.matches) {
          var p = parseSources("data-sources-p");
          if (p.length) return p;
        }
        return parseSources("data-sources");
      }

      function tryPlay() {
        var p = video.play();
        // autoplay can still be refused (iOS Low Power Mode) — the poster stays
        if (p && p.catch) p.catch(function () {});
      }

      // Attaches the right file for the current orientation. Safe to call
      // again on rotate: it no-ops unless the chosen URL actually changed.
      function loadForOrientation() {
        var srcs = sourcesForNow();
        if (!srcs.length) return false;

        // phones take the smallest source at or above 720px wide; desktop asks
        // for more than any source has, which falls through to the largest
        var want = mqDesktop.matches ? 99999 : 720;
        var pick = null;
        for (var i = 0; i < srcs.length; i++) {
          if (srcs[i].w >= want) { pick = srcs[i]; break; }
        }
        if (!pick) pick = srcs[srcs.length - 1];
        if (pick.url === loadedUrl) return true;

        // drop the fade class first, or the swap shows an empty frame at
        // full opacity while the new file buffers
        video.classList.remove("is-playing");
        loadedUrl = pick.url;
        video.src = pick.url;
        tryPlay();
        return true;
      }

      function start() {
        if (started) return;
        var conn = navigator.connection || navigator.webkitConnection || {};
        if (conn.saveData === true) return;
        if (/(^|\-)2g$/.test(conn.effectiveType || "")) return;

        if (!mqDesktop.matches && video.hasAttribute("data-desktop-only")) return;

        video.addEventListener("playing", function () {
          video.classList.add("is-playing");
        });
        if (!loadForOrientation()) return;
        started = true;

        // stop decoding once the hero has scrolled away, and while the tab is
        // backgrounded — a 45s loop left running is pure battery drain
        if ("IntersectionObserver" in window) {
          // held in a variable rather than left anonymous: an observer whose
          // only reference is the observation itself is a known GC footgun,
          // and the reveal observer above is written the same way
          var vio = new IntersectionObserver(function (e) {
            visible = e[0].isIntersecting;
            if (visible && !d.hidden) tryPlay(); else video.pause();
          }, { threshold: 0.01 });
          vio.observe(video);
        }
        d.addEventListener("visibilitychange", function () {
          if (d.hidden) video.pause();
          else if (visible) tryPlay();
        });
      }

      if (reduce) return;

      // let the poster win the LCP race before we ask the network for video
      var kick = function () { start(); };
      if ("requestIdleCallback" in window) requestIdleCallback(kick, { timeout: 1200 });
      else setTimeout(kick, 900);

      // Rotating a phone changes which crop is right, and can also cross into
      // the desktop branch if the merchant had mobile video switched off.
      if (mqPortrait.addEventListener) {
        mqPortrait.addEventListener("change", function () {
          if (started) loadForOrientation(); else start();
        });
      }
      if (mqDesktop.addEventListener) {
        mqDesktop.addEventListener("change", function (e) {
          if (started) loadForOrientation(); else if (e.matches) start();
        });
      }
      // Backstop for the two listeners above. Not every engine dispatches
      // MediaQueryList change reliably on rotate, and resize always fires.
      // loadForOrientation() no-ops unless the chosen URL actually changed,
      // so the mobile URL-bar resize storm costs a string compare.
      var rzT;
      window.addEventListener("resize", function () {
        clearTimeout(rzT);
        rzT = setTimeout(function () { if (started) loadForOrientation(); }, 250);
      });
    })(heroVideo);
  }

  /* ---- category card videos ------------------------------------------
     Four looping backgrounds under a hero that is already a looping video
     would be four decoders and a page with no still point, so these stay on
     their photo at rest and animate only on intent:

       pointer devices  hover or keyboard focus plays that one card
       touch devices    every card loops for as long as the row is on screen

     Sources are attached when the row first scrolls into view, so the first
     hover does not wait on the network, and never at all under reduced-motion. */
  var catVideos = Array.prototype.slice.call(d.querySelectorAll("[data-cat-video]"));
  if (catVideos.length) {
    (function () {
      // Only reduced-motion keeps the cards still. Save-Data and 2G used to as
      // well, but Data Saver is on by default on many Android phones and it
      // left every card on its photo, which is not what the client wants on
      // mobile: there the loops are the experience.
      if (reduce) return;

      function attach(video) {
        if (video.dataset.attached) return;
        var srcs = (video.getAttribute("data-sources") || "")
          .split(/\s+/)
          .map(function (tok) {
            var i = tok.indexOf("::");
            if (i < 1) return null;
            var url = tok.slice(i + 2);
            return url ? { w: parseInt(tok.slice(0, i), 10) || 0, url: url } : null;
          })
          .filter(Boolean)
          .sort(function (a, b) { return a.w - b.w; });
        if (!srcs.length) return;
        // a card is ~350px wide at most; the smallest source at or above 700
        // covers it at 2x, and only falls through to the largest if none is
        var pick = null;
        for (var i = 0; i < srcs.length; i++) {
          if (srcs[i].w >= 700) { pick = srcs[i]; break; }
        }
        if (!pick) pick = srcs[srcs.length - 1];
        video.dataset.attached = "1";
        video.preload = "metadata";
        video.src = pick.url;
        video.addEventListener("playing", function () { video.classList.add("is-playing"); });
      }

      function play(video) {
        if (!video) return;
        attach(video);
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
      }
      function stop(video, rewind) {
        if (!video) return;
        video.pause();
        video.classList.remove("is-playing");
        if (rewind) {
          // these clips are short camera moves, so a hover should open on the
          // start of the move instead of resuming mid-push
          try { video.currentTime = 0; } catch (e) {}
        }
      }

      // attach sources once the row is near, so hover feels instant
      var row = d.querySelector(".cats");
      if (row && "IntersectionObserver" in window) {
        var rowIo = new IntersectionObserver(function (entries, obs) {
          if (!entries[0].isIntersecting) return;
          catVideos.forEach(attach);
          obs.disconnect();
        }, { rootMargin: "200px 0px" });
        rowIo.observe(row);
      } else {
        catVideos.forEach(attach);
      }

      // Desktop is "has hover and a fine pointer"; phones and tablets fail that
      // query. maxTouchPoints is not a usable signal here: Windows reports touch
      // points on plenty of machines without a touch screen.
      if (window.matchMedia("(hover: hover) and (pointer: fine)").matches) {
        catVideos.forEach(function (video) {
          var card = video.closest(".cat");
          if (!card) return;
          card.addEventListener("pointerenter", function () { play(video); });
          card.addEventListener("pointerleave", function () { stop(video, true); });
          card.addEventListener("focusin", function () { play(video); });
          card.addEventListener("focusout", function () { stop(video, true); });
        });
      } else if (row && "IntersectionObserver" in window) {
        // Touch has no hover to trigger on, so the cards just run: every video
        // loops continuously for as long as the row is on screen. Still tied to
        // visibility, because decoding video the reader has scrolled past is
        // cost with no benefit. No rewind on the way out, so scrolling back
        // resumes the ambience instead of restarting it, and the 20% margin
        // keeps it from thrashing on and off at the boundary.
        var rowOn = false;
        var liveIo = new IntersectionObserver(function (entries) {
          rowOn = entries[0].isIntersecting && !d.hidden;
          catVideos.forEach(function (v) { if (rowOn) play(v); else stop(v, false); });
        }, { rootMargin: "20% 0px", threshold: 0 });
        liveIo.observe(row);
        // iOS in Low Power Mode rejects autoplay until the page has been touched;
        // the first gesture is enough, so try again on it (once per gesture type)
        ["touchstart", "touchend", "scroll"].forEach(function (evt) {
          window.addEventListener(evt, function retry() {
            window.removeEventListener(evt, retry);
            if (rowOn) catVideos.forEach(function (v) { if (v.paused) play(v); });
          }, { passive: true });
        });
      } else {
        // no IntersectionObserver: just run them, the visibility handler below
        // is still the backstop
        catVideos.forEach(play);
      }

      d.addEventListener("visibilitychange", function () {
        // not forEach(stop) — forEach hands the index in as the second
        // argument, which would make it the rewind flag for every card but
        // the first
        if (d.hidden) catVideos.forEach(function (v) { stop(v, false); });
      });
    })();
  }

  /* ---- mobile menu ---- */
  var burger = d.getElementById("burger");
  var menu = d.getElementById("mobileMenu");
  if (burger && menu) {
    var toggleMenu = function (force) {
      var open = force !== undefined ? force : !menu.classList.contains("open");
      menu.classList.toggle("open", open);
      burger.setAttribute("aria-expanded", open ? "true" : "false");
    };
    burger.addEventListener("click", function () { toggleMenu(); });
    menu.querySelectorAll("a").forEach(function (a) { a.addEventListener("click", function () { toggleMenu(false); }); });
  }

  /* ---- search bar (expands under the nav) ---- */
  var searchToggle = d.querySelector("[data-search-toggle]");
  var searchBar = d.getElementById("searchBar");
  var searchInput = d.getElementById("searchBarInput");
  if (searchToggle && searchBar) {
    var toggleSearch = function (force) {
      var open = force !== undefined ? force : !searchBar.classList.contains("open");
      searchBar.classList.toggle("open", open);
      searchBar.setAttribute("aria-hidden", open ? "false" : "true");
      searchToggle.setAttribute("aria-expanded", open ? "true" : "false");
      if (open && searchInput) { setTimeout(function () { searchInput.focus(); }, 200); }
    };
    searchToggle.addEventListener("click", function () { toggleSearch(); });
    d.addEventListener("keydown", function (e) { if (e.key === "Escape") toggleSearch(false); });
    d.addEventListener("click", function (e) {
      if (searchBar.classList.contains("open") && !searchBar.contains(e.target) && !searchToggle.contains(e.target)) {
        toggleSearch(false);
      }
    });
  }

  /* ---- header: stays pinned at all times (no hide-on-scroll). Any open
     mobile panel (menu/search) still closes the instant scrolling starts,
     so it isn't left floating under the nav. */
  if (nav) {
    var scrollTicking = false;
    d.addEventListener("scroll", function () {
      if (scrollTicking) return;
      scrollTicking = true;
      window.requestAnimationFrame(function () {
        if (menu && menu.classList.contains("open")) toggleMenu(false);
        if (searchBar && searchBar.classList.contains("open")) toggleSearch(false);
        scrollTicking = false;
      });
    }, { passive: true });
  }

  /* ---- collection filters (client-side, by product type) ---- */
  d.querySelectorAll("[data-filters]").forEach(function (fl) {
    var grid = d.querySelector("[data-grid]");
    if (!grid) return;
    fl.addEventListener("click", function (e) {
      var b = e.target.closest(".filter"); if (!b) return;
      fl.querySelectorAll(".filter").forEach(function (x) { x.classList.remove("active"); });
      b.classList.add("active");
      var cat = b.getAttribute("data-filter");
      grid.querySelectorAll(".pcard").forEach(function (c) {
        c.style.display = (cat === "all" || c.getAttribute("data-cat") === cat) ? "" : "none";
      });
    });
  });

  /* ================= CART ================= */
  var drawer = d.getElementById("cartDrawer");
  var overlay = d.getElementById("cartOverlay");

  function openCart() {
    if (!drawer) return;
    overlay.classList.add("open");
    drawer.classList.add("open");
    drawer.setAttribute("aria-hidden", "false");
    d.body.classList.add("locked");
  }
  function closeCart() {
    if (!drawer) return;
    overlay.classList.remove("open");
    drawer.classList.remove("open");
    drawer.setAttribute("aria-hidden", "true");
    d.body.classList.remove("locked");
  }
  if (overlay) overlay.addEventListener("click", closeCart);
  d.addEventListener("keydown", function (e) { if (e.key === "Escape") closeCart(); });

  function setCount(n) {
    d.querySelectorAll("[data-cart-count]").forEach(function (el) {
      el.textContent = n;
      el.classList.toggle("on", n > 0);
    });
  }

  function refreshCart() {
    return Promise.all([
      fetch(routes.root_url + "?sections=cart-drawer").then(function (r) { return r.json(); }),
      fetch(routes.cart_url + ".js").then(function (r) { return r.json(); })
    ]).then(function (res) {
      if (drawer && res[0] && res[0]["cart-drawer"] != null) { drawer.innerHTML = res[0]["cart-drawer"]; }
      setCount(res[1].item_count);
    });
  }

  function addVariant(id, qty) {
    if (!id) return Promise.resolve();
    return fetch(routes.cart_add_url + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: id, quantity: qty || 1 })
    })
      .then(function (r) { if (!r.ok) { throw new Error("add failed"); } return r.json(); })
      .then(function () { return refreshCart(); })
      .then(function () { openCart(); toast("Adăugat în coș"); })
      .catch(function () { toast("Momentan indisponibil"); });
  }

  function changeLine(line, qty) {
    return fetch(routes.cart_change_url + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function () { return refreshCart(); });
  }

  /* ---- "factură pe email -1%" opt-in (cart page + cart drawer) ----
     Checking the box saves a cart attribute (visible on the order) and,
     on checkout, routes through Shopify's native discount-link endpoint
     so the code is applied automatically — no app or checkout dev needed.
     Delegated (not a captured reference) so it keeps working after the
     drawer's innerHTML gets replaced by refreshCart(); the checkout button
     looks at the checkbox inside its OWN <form>, so page and drawer act
     independently even if both exist in the DOM at once. */
  function setCartAttributes(attrs) {
    return fetch(routes.cart_url + "/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ attributes: attrs })
    });
  }
  d.addEventListener("change", function (e) {
    var box = e.target.closest("[data-invoice-discount]");
    if (!box) return;
    setCartAttributes({ "Factură pe email (-1%)": box.checked ? "Da" : "" });
  });

  /* ---- T&C consent (cart page + cart drawer) ----
     Same mechanics as the invoice box: the state is mirrored into a cart
     attribute, so it survives the drawer re-render and lands on the order
     (Admin → order → Additional details) as proof of acceptance. The
     checkout button refuses to go on while the box is unchecked; the
     required attribute on the input is the no-JS fallback. */
  d.addEventListener("change", function (e) {
    var terms = e.target.closest("[data-terms-accept]");
    if (!terms) return;
    var lbl = terms.closest("label");
    if (lbl) { lbl.classList.remove("is-error"); }
    setCartAttributes({ "Termeni și condiții": terms.checked ? "Acceptat" : "" });
  });

  /* delegated interactions (survive drawer re-render) */
  d.addEventListener("click", function (e) {
    var openBtn = e.target.closest("[data-cart-open]");
    if (openBtn) { e.preventDefault(); openCart(); return; }
    var closeBtn = e.target.closest("[data-cart-close]");
    if (closeBtn) { e.preventDefault(); closeCart(); return; }
    var add = e.target.closest("[data-variant-id]");
    if (add && !add.disabled) { e.preventDefault(); addVariant(add.getAttribute("data-variant-id"), 1); return; }
    var ch = e.target.closest("[data-line-change]");
    if (ch) { e.preventDefault(); changeLine(parseInt(ch.getAttribute("data-line"), 10), parseInt(ch.getAttribute("data-qty"), 10)); return; }
    var checkoutBtn = e.target.closest("[data-checkout-btn]");
    if (checkoutBtn) {
      var form = checkoutBtn.closest("form");
      var terms = form ? form.querySelector("[data-terms-accept]") : null;
      if (terms && !terms.checked) {
        e.preventDefault();
        var lbl = terms.closest("label");
        if (lbl) {
          lbl.classList.add("is-error");
          if (lbl.scrollIntoView) { lbl.scrollIntoView({ block: "nearest", behavior: "smooth" }); }
        }
        toast("Bifează acordul cu Termenii și Condițiile");
        return;
      }
      var box = form ? form.querySelector("[data-invoice-discount]") : null;
      if (box && box.checked) {
        var code = box.getAttribute("data-discount-code");
        if (code) {
          e.preventDefault();
          /* the discount link skips the cart form POST, so make sure both
             attributes are on the cart before leaving the page */
          var attrs = { "Factură pe email (-1%)": "Da" };
          if (terms) { attrs["Termeni și condiții"] = "Acceptat"; }
          var go = function () { window.location.href = "/discount/" + encodeURIComponent(code) + "?redirect=/checkout"; };
          setCartAttributes(attrs).then(go, go);
        }
      }
      return;
    }
  });

  /* product page form → AJAX add */
  d.addEventListener("submit", function (e) {
    var f = e.target.closest('form[action*="/cart/add"]');
    if (!f) return;
    e.preventDefault();
    var idField = f.querySelector('[name="id"]');
    if (idField && idField.value) addVariant(idField.value, 1);
  });

  /* toast */
  var toastEl = d.getElementById("toast");
  var toastMsg = d.getElementById("toastMsg");
  var tT;
  function toast(msg) {
    if (!toastEl) return;
    toastMsg.textContent = msg;
    toastEl.classList.add("show");
    clearTimeout(tT);
    tT = setTimeout(function () { toastEl.classList.remove("show"); }, 2200);
  }
})();
